<template>
  <div
    class="relative overflow-hidden max-w-full after:absolute after:inset-0 after:bg-gradient-to-r after:from-white after:via-transparent after:to-white"
  >
    <div class="slider relative overflow-hidden flex w-max min-w-[200%]">
      <div class="w-1/2">
        <slot></slot>
      </div>
      <div class="w-1/2">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
@keyframes moveSlideshow {
  100% {
    transform: translateX(-50%);
  }
}

.slider {
  transform: translate3d(0, 0, 0);
  animation-name: moveSlideshow;
  animation-duration: 30s;
  animation-direction: normal;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>
